import React, { forwardRef } from "react";
import SelectOption from "../../../../../../components/SelectOption";
import { useApi } from "../../../../../../hooks/http2";
import { URL_API, _ } from "../../../../../../utils";

const SelectColor = (props) => {
  const list = useApi(
    {
      url: `${URL_API}/setting/master/product-color`,
      token: true,
    },
    []
  );

  return (
    <SelectOption
      loading={list.loading}
      data={_.map(list.fetch?.data || [], (n) => ({
        value: n.id?.toString(),
        text: `${n.name_local} - ${n.name_en}`,
      }))}
      withAll
      allText={
        (list.fetch?.data || []).length > 0 ? "เลือกสี" : "-- ไม่มีข้อมูล --"
      }
      {...props}
    />
  );
};

export default forwardRef((props, ref) => {
  return <SelectColor forwardRef={ref} {...props} />;
});
